// extracted by mini-css-extract-plugin
module.exports = {"container":"BlockQuote_container__Bvbuy","iconWrapper":"BlockQuote_iconWrapper__5_8M4","quote":"BlockQuote_quote__dTJdI","footer":"BlockQuote_footer__7mRxw"};